import { useEffect, useState } from 'react';

const getInitialTheme = (): boolean => {
  if (typeof document !== 'undefined') {
    return document.body.classList.contains('theme-dark');
  }
  return false;
};

export const useCurrentTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(getInitialTheme);

  useEffect(() => {
    const checkTheme = () => {
      const isDark = document.body.classList.contains('theme-dark');

      // Only update state if the value actually changed
      setIsDarkMode((prevIsDarkMode) => {
        if (prevIsDarkMode !== isDark) {
          return isDark;
        }
        return prevIsDarkMode;
      });
    };

    // Initial check
    checkTheme();

    // Set up observer to watch for class changes
    const observer = new MutationObserver(checkTheme);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return { isDarkMode };
};
